import ajax from '@ajax';

/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */
const basePath = '/teammate/api'.replace(/\/$/, '');
/**
  *
  * @summary agent列表
  * @param params ParamsgetAgentList
  
  * @param opt ajax config
  * @returns models.ApiResultPageQueryResultVOAgentVO
  */
const getAgentList = (params, opt) => {
    const path = '/agent/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('page' in params)
        p.query.page = params.page;
    if ('size' in params)
        p.query.size = params.size;
    if ('version' in params)
        p.query.version = params.version;
    if ('searchStr' in params)
        p.query.searchStr = params.searchStr;
    if ('includeCoordinator' in params)
        p.query.includeCoordinator = params.includeCoordinator;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 获取群成员信息
  * @param params ParamscallbackGetChannelInfoUsingGet
  
  * @param opt ajax config
  * @returns models.ApiResultCallbackChannelInfoDTO
  */
const callbackGetChannelInfoUsingGet = (params, opt) => {
    const path = '/callback/get_channel_info';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('sessionId' in params)
        p.query.sessionId = params.sessionId;
    ajax.check(params.sessionId, 'sessionId');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 手动触发超时恢复（运维用）
  * @param params ParamsforceTimeoutRecovery
  
  * @param opt ajax config
  * @returns models.ApiResultBoolean
  */
const forceTimeoutRecovery = (params, opt) => {
    const path = '/callback/force-timeout-recovery';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('channelId' in params)
        p.query.channelId = params.channelId;
    ajax.check(params.channelId, 'channelId');
    if ('agentId' in params)
        p.query.agentId = params.agentId;
    ajax.check(params.agentId, 'agentId');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary v2 Coordinator 执行完成回调
  
  * @param data: ParamsBodyonExecutionComplete
  * @param opt ajax config
  * @returns models.ApiResultBoolean
  */
const onExecutionComplete = (data, opt) => {
    const path = '/callback/execution-complete';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary Agent 发送 KIM 消息
  
  * @param data: ParamsBodysendKimMessage
  * @param opt ajax config
  * @returns models.ApiResultBoolean
  */
const sendKimMessage = (data, opt) => {
    const path = '/callback/agent/send_kim_message';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary channel中新加入agent
  
  * @param data: ParamsBodychannelAddAgents
  * @param opt ajax config
  * @returns models.ApiResultChannelDetailVO
  */
const channelAddAgents = (data, opt) => {
    const path = '/channel/add-agent';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary channel中新加入user
  
  * @param data: ParamsBodychannelAddUsers
  * @param opt ajax config
  * @returns models.ApiResultChannelDetailVO
  */
const channelAddUsers = (data, opt) => {
    const path = '/channel/add-user';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary channel中移除agent
  
  * @param data: ParamsBodychannelRemoveAgents
  * @param opt ajax config
  * @returns models.ApiResultChannelDetailVO
  */
const channelRemoveAgents = (data, opt) => {
    const path = '/channel/remove-agent';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary channel中移除user
  
  * @param data: ParamsBodychannelRemoveUsers
  * @param opt ajax config
  * @returns models.ApiResultChannelDetailVO
  */
const channelRemoveUsers = (data, opt) => {
    const path = '/channel/remove-user';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 新建channel
  
  * @param data: ParamsBodycreateChannel
  * @param opt ajax config
  * @returns models.ApiResultChannelDetailVO
  */
const createChannel = (data, opt) => {
    const path = '/channel/create';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 删除channel
  * @param params ParamsdeleteChannel
  
  * @param opt ajax config
  * @returns models.ApiResultBoolean
  */
const deleteChannel = (params, opt) => {
    const path = '/channel/delete';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('channelId' in params)
        p.query.channelId = params.channelId;
    ajax.check(params.channelId, 'channelId');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary channel详情
  * @param params ParamsgetChannelInfo1
  
  * @param opt ajax config
  * @returns models.ApiResultChannelDetailVO
  */
const getChannelInfo1 = (params, opt) => {
    const path = '/channel/detail';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('channelId' in params)
        p.query.channelId = params.channelId;
    ajax.check(params.channelId, 'channelId');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary channel列表
  * @param params ParamsgetChannelList
  
  * @param opt ajax config
  * @returns models.ApiResultPageQueryResultVOChannelListItemVO
  */
const getChannelList = (params, opt) => {
    const path = '/channel/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('page' in params)
        p.query.page = params.page;
    if ('size' in params)
        p.query.size = params.size;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 按agent分页查询关联channel
  * @param params ParamsgetChannelListByAgentId
  
  * @param opt ajax config
  * @returns models.ApiResultPageQueryResultVOAgentRelatedChannelListItemVO
  */
const getChannelListByAgentId = (params, opt) => {
    const path = '/channel/list-by-agent';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('agentId' in params)
        p.query.agentId = params.agentId;
    ajax.check(params.agentId, 'agentId');
    if ('page' in params)
        p.query.page = params.page;
    if ('size' in params)
        p.query.size = params.size;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 标记channel已读水位
  
  * @param data: ParamsBodymarkReadWatermark
  * @param opt ajax config
  * @returns models.ApiResultBoolean
  */
const markReadWatermark = (data, opt) => {
    const path = '/channel/mark-read-watermark';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 更新channel中agent是否需要@才响应
  
  * @param data: ParamsBodyupdateAgentReplyNeedAt
  * @param opt ajax config
  * @returns models.ApiResultBoolean
  */
const updateAgentReplyNeedAt = (data, opt) => {
    const path = '/channel/update-agent-reply-need-at';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 更新channel名称
  
  * @param data: ParamsBodyupdateChannelName
  * @param opt ajax config
  * @returns models.ApiResultBoolean
  */
const updateChannelName = (data, opt) => {
    const path = '/channel/update-name';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 拉取频道历史消息（经 KIM 群）
  * @param params ParamslistHistoryMessages
  
  * @param opt ajax config
  * @returns models.ApiResultPageQueryResultVOImMessageVO
  */
const listHistoryMessages = (params, opt) => {
    const path = '/im/history-messages';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('channel_id' in params)
        p.query.channel_id = params.channel_id;
    ajax.check(params.channel_id, 'channel_id');
    if ('seqId' in params)
        p.query.seqId = params.seqId;
    if ('count' in params)
        p.query.count = params.count;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 获取频道信息
  * @param params ParamsgetChannelInfo
  
  * @param opt ajax config
  * @returns models.ApiResultChannelInfo
  */
const getChannelInfo = (params, opt) => {
    const path = '/skill/get_channel_info';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('sessionKey' in params)
        p.query.sessionKey = params.sessionKey;
    ajax.check(params.sessionKey, 'sessionKey');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 读取频道历史消息
  * @param params ParamsreadHistory
  
  * @param opt ajax config
  * @returns models.ApiResultTeammateMessagesDTO
  */
const readHistory = (params, opt) => {
    const path = '/skill/read_history';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('sessionKey' in params)
        p.query.sessionKey = params.sessionKey;
    ajax.check(params.sessionKey, 'sessionKey');
    if ('seqId' in params)
        p.query.seqId = params.seqId;
    if ('count' in params)
        p.query.count = params.count;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 拉取 Inbox 中待处理消息列表
  * @param params ParamsreadInboxMessageList
  
  * @param opt ajax config
  * @returns models.ApiResultTeammateMessagesDTO
  */
const readInboxMessageList = (params, opt) => {
    const path = '/skill/read_inbox_message_list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('sessionKey' in params)
        p.query.sessionKey = params.sessionKey;
    ajax.check(params.sessionKey, 'sessionKey');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 发送运行期消息
  * @param params ParamssendMessage
  * @param data: ParamsBodysendMessage
  * @param opt ajax config
  * @returns models.ApiResultVoid
  */
const sendMessage = (params, data, opt) => {
    const path = '/skill/send_message';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('sessionKey' in params)
        p.query.sessionKey = params.sessionKey;
    ajax.check(params.sessionKey, 'sessionKey');
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 直接触发 MessageDispatchService
  
  * @param data: ParamsBodydispatchMessage
  * @param opt ajax config
  * @returns models.ApiResultString
  */
const dispatchMessage = (data, opt) => {
    const path = '/test/dispatch-message';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 检查 kimGroupId 是否已绑定频道
  * @param params ParamsexistsChannel
  
  * @param opt ajax config
  * @returns models.ApiResultBoolean
  */
const existsChannel = (params, opt) => {
    const path = '/test/exists-channel';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('kimGroupId' in params)
        p.query.kimGroupId = params.kimGroupId;
    ajax.check(params.kimGroupId, 'kimGroupId');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 查询指定 agent 的 inbox 状态
  * @param params ParamsgetInboxState
  
  * @param opt ajax config
  * @returns models.ApiResultInboxState
  */
const getInboxState = (params, opt) => {
    const path = '/test/inbox-state';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('channelId' in params)
        p.query.channelId = params.channelId;
    ajax.check(params.channelId, 'channelId');
    if ('agentId' in params)
        p.query.agentId = params.agentId;
    ajax.check(params.agentId, 'agentId');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 查询 v2 thread chat task 是否已完成
  * @param params ParamsisV2TaskCompleted
  
  * @param opt ajax config
  * @returns models.ApiResultBoolean
  */
const isV2TaskCompleted = (params, opt) => {
    const path = '/test/v2-task-completed';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('channelId' in params)
        p.query.channelId = params.channelId;
    ajax.check(params.channelId, 'channelId');
    if ('sessionId' in params)
        p.query.sessionId = params.sessionId;
    ajax.check(params.sessionId, 'sessionId');
    if ('chatTaskId' in params)
        p.query.chatTaskId = params.chatTaskId;
    ajax.check(params.chatTaskId, 'chatTaskId');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 拉取指定 agent 的待执行消息
  * @param params ParamspullPendingExecution
  
  * @param opt ajax config
  * @returns models.ApiResultMergedExecutionMessage
  */
const pullPendingExecution = (params, opt) => {
    const path = '/test/pull-pending-execution';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('channelId' in params)
        p.query.channelId = params.channelId;
    ajax.check(params.channelId, 'channelId');
    if ('agentId' in params)
        p.query.agentId = params.agentId;
    ajax.check(params.agentId, 'agentId');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 查询频道详情（走主库）
  * @param params ParamstestChannelDetailUsingGet
  
  * @param opt ajax config
  * @returns models.ApiResultChannelDetailDTO
  */
const testChannelDetailUsingGet = (params, opt) => {
    const path = '/test/channel-detail';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('channelId' in params)
        p.query.channelId = params.channelId;
    ajax.check(params.channelId, 'channelId');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @summary 批量从 Redis 读取头像缓存（用户与 Agent id 共用；需曾通过 RPC 写入）
  
  * @param data: ParamsBodybatchGetAvatars
  * @param opt ajax config
  * @returns models.ApiResultBatchAvatarVO
  */
const batchGetAvatars = (data, opt) => {
    const path = '/user/avatars/batch';
    const url = basePath + path;
    const p = {};
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 当前用户信息
  
  
  * @param opt ajax config
  * @returns models.ApiResultMyInfoVO
  */
const getMyInfo = (opt) => {
    const path = '/user/me';
    const url = basePath + path;
    const p = {};
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};

export { batchGetAvatars, callbackGetChannelInfoUsingGet, channelAddAgents, channelAddUsers, channelRemoveAgents, channelRemoveUsers, createChannel, deleteChannel, dispatchMessage, existsChannel, forceTimeoutRecovery, getAgentList, getChannelInfo, getChannelInfo1, getChannelList, getChannelListByAgentId, getInboxState, getMyInfo, isV2TaskCompleted, listHistoryMessages, markReadWatermark, onExecutionComplete, pullPendingExecution, readHistory, readInboxMessageList, sendKimMessage, sendMessage, testChannelDetailUsingGet, updateAgentReplyNeedAt, updateChannelName };
